<div class="conv-list" role="dialog" aria-modal="true" aria-labelledby="conv-list-title">
  <div class="conv-list__head">
    <span class="conv-list__title" id="conv-list-title">{{ 'NOVA_CONVERSATIONS' | translate }}</span>
    <div class="conv-list__actions">
      <button type="button" class="conv-list__new" (click)="newConversation.emit()" [attr.aria-label]="'NOVA_NEW_CONVERSATION' | translate" [title]="'NOVA_NEW_CONVERSATION' | translate">
        <ion-icon name="create-outline"></ion-icon>
      </button>
      <button type="button" class="conv-list__close" (click)="dismiss.emit()" [attr.aria-label]="'CLOSE' | translate">
        <ion-icon name="close"></ion-icon>
      </button>
    </div>
  </div>

  <div class="conv-list__body">
    <div class="conv-list__loading" *ngIf="loading" role="status">
      <ion-spinner name="dots"></ion-spinner>
    </div>

    <p class="conv-list__empty" *ngIf="!loading && !groups.length">{{ 'NOVA_NO_PREVIOUS_CONVERSATIONS' | translate }}</p>

    <ng-container *ngFor="let group of groups; trackBy: trackByGroup">
      <p class="conv-list__group-label">{{ group.labelKey | translate }}</p>
      <div class="conv-list__row" *ngFor="let entry of group.entries; trackBy: trackById">
        <button
          type="button"
          class="conv-list__row-open"
          (click)="resume.emit(entry)">
          <span class="conv-list__row-main">
            <span class="conv-list__row-title">{{ entry.title }}</span>
            <span class="conv-list__row-date">{{ formatDate(entry.lastAt) }}</span>
          </span>
          <span class="conv-list__row-snippet" *ngIf="entry.snippet">{{ entry.snippet }}</span>
        </button>
        <button
          type="button"
          class="conv-list__row-delete"
          (click)="onDelete($event, entry)"
          [attr.aria-label]="'NOVA_DELETE_CONVERSATION_LABEL' | translate: { title: entry.title }"
          [title]="'NOVA_DELETE_CONVERSATION' | translate">
          <ion-icon name="trash-outline" aria-hidden="true"></ion-icon>
        </button>
      </div>
    </ng-container>
  </div>
</div>
